import type { MouseEvent } from 'react';

import type { MenuItem } from '@shared-types/menu.types';
import GoogleTagManagerHelper from '@tracking/gtm-helper';

export const handleHeaderItemClick =
  ({ trackText }: Pick<MenuItem, 'trackText'>) =>
  (event: MouseEvent<HTMLElement>) => {
    if (event.button > 1) return;
    event.stopPropagation();

    sendHeaderTracking(trackText, 'Access');
  };

export const sendHeaderTracking = (trackText: string, prefix = 'Access') => {
  GoogleTagManagerHelper.ga4Event('navigation_main', {
    navigation_type: `${prefix} - ${trackText}`,
  });
};
